// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xat4Q","title":"Header_title__3julf","left":"Header_left__2vETZ","clinicName":"Header_clinicName__2ps3S"};